import React from "react";
import { listMyUpcomingAppointmentSnapshots } from "@/services/patientAppointmentSnapshots.js";

/**
 * SSOT: Upcoming appointments for patient surfaces.
 * Uses the DB-backed snapshot service so Home, /appointments, and details
 * stay aligned even when route/session state is stale.
 * Auto-refresh when we dispatch: window.dispatchEvent(new Event("afrimed:appointments:changed"))
 */
export default function useMyUpcomingAppointments() {
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState("");
  const [items, setItems] = React.useState([]);

  const load = React.useCallback(async () => {
    setLoading(true);
    setError("");

    try {
      const data = await listMyUpcomingAppointmentSnapshots();
      setItems(Array.isArray(data) ? data : []);
    } catch (e) {
      setItems([]);
      setError(e?.message || "Unable to load upcoming appointments.");
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    load();
    const onChanged = () => load();
    window.addEventListener("afrimed:appointments:changed", onChanged);
    return () => window.removeEventListener("afrimed:appointments:changed", onChanged);
  }, [load]);

  return { loading, error, items, refetch: load };
}
